(function () {
    'use strict';

    var $ = function(sel, root) { return (root || document).querySelector(sel); };
    var $$ = function(sel, root) { return Array.from((root || document).querySelectorAll(sel)); };

    // Skutečná šířka in-flow obsahu (text + inline prvky). Sčítá šířky jednotlivých potomků,
    // takže funguje i v Safari/WebKitu (kde scrollWidth flex kontejneru přetečení nehlásí)
    // a zároveň IGNORUJE absolutně pozicované prvky – např. šipku .card-cta-arrow (right: 24px),
    // která jinak měření roztáhne přes celou šířku tlačítka a font se zmenšuje zbytečně.
    function contentWidth(el) {
        var cs = getComputedStyle(el);
        var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
        var total = 0;
        var count = 0;
        Array.prototype.forEach.call(el.childNodes, function(node) {
            var w = 0;
            if (node.nodeType === 3) { // textový uzel
                if (!node.nodeValue.trim()) return;
                var range = document.createRange();
                range.selectNode(node);
                w = range.getBoundingClientRect().width;
                range.detach && range.detach();
            } else if (node.nodeType === 1) { // element
                if (getComputedStyle(node).position === 'absolute') return; // absolutní šipku přeskoč
                w = node.getBoundingClientRect().width;
            } else {
                return;
            }
            total += w;
            count++;
        });
        if (count > 1) total += gap * (count - 1);
        return total;
    }

    // Dostupná šířka pro obsah = vnitřní šířka minus horizontální padding.
    function availableWidth(el) {
        var cs = getComputedStyle(el);
        return el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    }

    // Zmenšuje font, dokud se obsah nevejde. Sdílená logika pro CTA i tlačítka.
    function shrinkToFit(el, minFontSize) {
        el.style.fontSize = '';
        // Skrytý prvek nemá rozměry a vnitřní padding by z dostupné šířky udělal záporné
        // číslo – měření by mu bez tohohle kroku sjelo font rovnou na minimum.
        if (!el.getClientRects().length) return;
        var fontSize = parseFloat(getComputedStyle(el).fontSize);
        // +0.5 tolerance kvůli subpixelovému zaokrouhlení
        while (contentWidth(el) > availableWidth(el) + 0.5 && fontSize > minFontSize) {
            fontSize -= 0.5;
            el.style.fontSize = fontSize + 'px';
        }
    }

    // Skutečná šířka textu i tehdy, když ho overflow: hidden vizuálně ořezal – Range
    // se ořezáním neřídí. scrollWidth/clientWidth tady použít NELZE: jsou zaokrouhlené
    // na celé pixely, takže krabice širokou 153.7px hlásí jako 154 a text o šířce
    // 153.8px vypadá jako "vejde se", i když ho Chrome zkrátil trojtečkou.
    function textWidth(el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var w = range.getBoundingClientRect().width;
        range.detach && range.detach();
        return w;
    }

    function innerWidth(el) {
        var cs = getComputedStyle(el);
        return el.getBoundingClientRect().width
            - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)
            - parseFloat(cs.borderLeftWidth) - parseFloat(cs.borderRightWidth);
    }

    // Zmenšuje font, dokud se text vejde do místa, které prvku nechal flexbox.
    // Prvek musí mít overflow: hidden a white-space: nowrap (viz .card-name):
    // dokud se text vejde, krabice se drží obsahu (rozdíl je nula), jakmile přeteče,
    // flexbox ji zúží a rozdíl vyskočí – proto stačí prahová hodnota 0.01px, oba
    // rozměry pocházejí ze stejného layoutu.
    function shrinkTextToFit(el, minFontSize) {
        el.style.fontSize = '';
        var fontSize = parseFloat(getComputedStyle(el).fontSize);
        while (textWidth(el) - innerWidth(el) > 0.01 && fontSize > minFontSize) {
            fontSize -= 0.5;
            el.style.fontSize = fontSize + 'px';
        }
    }

    function fitCtaText(card) {
        var cta = $('.card-cta', card);
        if (!cta) return;
        shrinkToFit(cta, 10);
    }

    // ---- Názvy karet: zmenšení fontu, aby cena ani šipka nikdy neuhnuly ----
    // Cena vpravo (.card-head-right) i šipka mají pevnou šířku, .card-name se jako
    // jediný prvek hlavičky smrskne – proto stačí porovnat, kolik místa mu zbylo.
    function fitCardNames() {
        $$('.card-name').forEach(function(name) { shrinkTextToFit(name, 10); });
    }

    // Stejný princip u řádků funkcí: název ustoupí, hodnota s ikonou drží pozici.
    // Měřit jde až po rozbalení karty – ve skrytém .card-body mají prvky nulovou šířku.
    function fitFeatureLabels(card) {
        $$('.feature-label-text', card).forEach(function(label) { shrinkTextToFit(label, 9); });
    }

    function expandCard(card) {
        var stack = card.parentElement;
        $$('.card.is-expanded', stack).forEach(function(c) { if (c !== card) collapseCard(c); });
        card.classList.add('is-expanded');
        var body = $('.card-body', card);
        if (body) body.hidden = false;
        fitCtaText(card);
        fitFeatureLabels(card);
        var chev = $('.chev-host .chev', card);
        if (chev) { chev.classList.remove('chev--down'); chev.classList.add('chev--up'); }
    }

    function collapseCard(card) {
        card.classList.remove('is-expanded');
        var body = $('.card-body', card);
        if (body) body.hidden = true;
        var chev = $('.chev-host .chev', card);
        if (chev) { chev.classList.remove('chev--up'); chev.classList.add('chev--down'); }
    }

    function toggleCard(card) {
        if (card.classList.contains('is-expanded')) collapseCard(card);
        else expandCard(card);
    }

    document.body.addEventListener('click', function(e) {
        var head = e.target.closest('.card-head');
        if (head) {
            var card = head.closest('.card');
            if (card && !card.classList.contains('is-disabled')) {
                if (!e.target.closest('a, [data-ev-vat-toggle]')) {
                    toggleCard(card);
                }
            }
        }
    });

    document.body.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.card');
        if (card && e.target === card && !card.classList.contains('is-disabled')) {
            e.preventDefault();
            // zamčenou kartu klávesnicí neotevřeme – roh se dá trefit jen myší/prstem
            if ($('.card-head[data-ev-locked]', card)) {
                openLockedDialog();
                return;
            }
            toggleCard(card);
        }
    });

    // ---- Dočasně vypnuté karty: rozbalí je jen odemykací roh vlevo nahoře ----
    // Zákazník kartu neotevře, jen mu vyskočí hláška o připravované funkci. My se dovnitř
    // dostaneme klepnutím do levého horního rohu boxu. Roh pouští vždycky jen ten jeden klik,
    // zámek zůstává – proto sedí na hlavičce, aby tlačítko uvnitř rozbalené karty fungovalo.
    var LOCK_HOTSPOT = { width: 28, height: 18 };

    function isHotspotClick(el, e) {
        // klik vyvolaný klávesnicí nemá souřadnice – ten nepouštíme nikdy
        if (!e.clientX && !e.clientY) return false;
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        return x >= 0 && x <= LOCK_HOTSPOT.width && y >= 0 && y <= LOCK_HOTSPOT.height;
    }

    function openLockedDialog() {
        var dialog = $('[data-ev-dialog]');
        if (!dialog) return;
        dialog.hidden = false;
        // font tlačítka jde měřit až teď, když má dialog rozměry (delší překlady DE/PL)
        $$('.btn', dialog).forEach(fitButton);
    }

    function closeLockedDialog() {
        var dialog = $('[data-ev-dialog]');
        if (dialog) dialog.hidden = true;
    }

    // capture fáze, ať jsme dřív než rozbalování karty
    document.addEventListener('click', function(e) {
        var locked = e.target.closest('[data-ev-locked]');
        if (!locked || e.target.closest('[data-ev-vat-toggle]') || isHotspotClick(locked, e)) return;
        e.preventDefault();
        e.stopPropagation();
        openLockedDialog();
    }, true);

    document.addEventListener('click', function(e) {
        // zavírá křížek/tlačítko i klik do ztmavlého pozadí mimo box
        if (e.target.closest('[data-ev-dialog-close]') || e.target.hasAttribute('data-ev-dialog')) {
            closeLockedDialog();
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeLockedDialog();
    });

    // ---- Ceny s DPH / bez DPH: klepnutí na částku přepne všechny částky na obrazovce ----
    // Volba se mezi obrazovkami nepamatuje, každá začíná s DPH. Překreslení snippetu (jazyk, měna) ji drží.
    var vatExcluded = false;

    function applyVatMode() {
        $$('[data-ev-vat-incl]').forEach(function(el) {
            el.textContent = el.getAttribute(vatExcluded ? 'data-ev-vat-excl' : 'data-ev-vat-incl');
        });
    }

    document.addEventListener('click', function(e) {
        if (!e.target.closest('[data-ev-vat-toggle]')) return;
        vatExcluded = !vatExcluded;
        applyVatMode();
        // jiná délka ceny mění místo pro název karty
        refitEverything();
    });

    // ---- Otazníčky u funkcí balíčku: pod řádkem rozbalí vysvětlení, otevřené je vždy jen jedno ----
    // Delegace na document, protože přepnutí jazyka/měny překreslí snippet store přes AJAX.
    function setHint(btn, open) {
        var hint = document.getElementById(btn.getAttribute('aria-controls'));
        if (!hint) return;
        hint.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeHints(except) {
        $$('[data-ev-hint][aria-expanded="true"]').forEach(function(btn) {
            if (btn !== except) setHint(btn, false);
        });
    }

    document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-ev-hint]');
        if (!btn) return;
        closeHints(btn);
        setHint(btn, btn.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeHints(null);
    });

    // ---- Potvrzovací tlačítka: zmenšení fontu, když by text přetékal (delší překlady DE/PL) ----
    function fitButton(btn) {
        shrinkToFit(btn, 11);
    }

    function fitButtons() {
        $$('.btn').forEach(fitButton);
    }

    // ---- Nadpisy obrazovek: zmenšení fontu, když by se text nevešel na jeden řádek ----
    // Nadpis .screen-title--inline je flex prvek v .screen-header a sám se roztáhne na obsah,
    // takže dostupnou šířku musíme brát z rodiče a odečíst absolutní šipku zpět.
    function fitTitle(title) {
        title.style.fontSize = '';
        // skrytý nadpis nemá rozměry, font by sjel na minimum
        if (!title.getClientRects().length) return;
        var parent = title.parentElement;
        if (!parent) return;
        var pcs = getComputedStyle(parent);
        var available = parent.clientWidth - parseFloat(pcs.paddingLeft) - parseFloat(pcs.paddingRight);
        var isFlexRow = pcs.display.indexOf('flex') !== -1 && pcs.flexDirection.indexOf('row') !== -1;
        // ve flex headeru zaberou místo sourozenci (šipka zpět je absolutní, ale reálně kolem sebe potřebuje místo)
        if (isFlexRow) {
            Array.prototype.forEach.call(parent.children, function(child) {
                if (child !== title) available -= child.getBoundingClientRect().width;
            });
        }
        var fontSize = parseFloat(getComputedStyle(title).fontSize);
        while (contentWidth(title) > available + 0.5 && fontSize > 13) {
            fontSize -= 0.5;
            title.style.fontSize = fontSize + 'px';
        }
    }

    function fitTitles() {
        $$('.screen-title').forEach(fitTitle);
    }

    // ---- Uložení/obnovení rozbalených karet (zachování stavu při AJAX překreslení) ----
    function saveExpandedCards() {
        var state = {};
        $$('.card-stack').forEach(function(stack, si) {
            $$('.card', stack).forEach(function(card, ci) {
                if (card.classList.contains('is-expanded')) state[si] = ci;
            });
        });
        return state;
    }

    function restoreExpandedCards(state) {
        $$('.card-stack').forEach(function(stack, si) {
            if (state[si] !== undefined) {
                var cards = $$('.card', stack);
                if (cards[state[si]]) expandCard(cards[state[si]]);
            }
        });
    }

    function saveFieldValues() {
        var state = {};
        $$('input[name], select[name], textarea[name]').forEach(function(el) {
            if (el.type === 'hidden' || el.type === 'password') return;
            state[el.name] = el.type === 'checkbox' || el.type === 'radio' ? el.checked : el.value;
        });
        return state;
    }

    function restoreFieldValues(state) {
        $$('input[name], select[name], textarea[name]').forEach(function(el) {
            if (!(el.name in state)) return;
            if (el.type === 'checkbox' || el.type === 'radio') el.checked = state[el.name];
            else el.value = state[el.name];
        });
    }

    // ---- Přepínač jazyka/měny bez přenačtení celé stránky (AJAX snippet) ----
    function applySnippets(payload) {
        if (payload.redirect) { window.location.href = payload.redirect; return; }
        var expandedState = saveExpandedCards();
        var fieldState = saveFieldValues();
        var snippets = payload.snippets || {};
        Object.keys(snippets).forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.innerHTML = snippets[id];
        });
        if (payload.url) window.history.replaceState(null, '', payload.url);
        restoreExpandedCards(expandedState);
        restoreFieldValues(fieldState);
        applyVatMode();
        // snippet přepsal innerHTML, takže původní .card-stack už neexistuje
        observeStacks();
        syncTermsGates();
        refitEverything();
    }

    function ajaxSwitch(url) {
        fetch(url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
        })
            .then(function(r) { return r.json(); })
            .then(function(payload) {
                applySnippets(payload);
                // snippet má cenu podle uložených údajů, obnovená pole mohou být jiná
                var recalculate = $('[data-ev-billing-recalculate-submit]');
                if (recalculate && !payload.redirect) recalculateBilling(recalculate.form);
            })
            .catch(function() { window.location.href = url; });
    }

    document.addEventListener('click', function(e) {
        // rozbalení/zabalení vlaječek
        var toggle = e.target.closest('[data-ev-lang-toggle]');
        if (toggle) {
            e.stopPropagation();
            var wrap = toggle.closest('[data-ev-lang]');
            if (wrap) {
                var open = wrap.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            }
            return;
        }

        // AJAX přepnutí jazyka/měny
        var link = e.target.closest('[data-ev-switch]');
        if (link && link.href) {
            e.preventDefault();
            ajaxSwitch(link.href);
            return;
        }

        // zavření flyoutu při kliku mimo
        var openWrap = $('[data-ev-lang].is-open');
        if (openWrap && !openWrap.contains(e.target)) {
            openWrap.classList.remove('is-open');
            var t = $('[data-ev-lang-toggle]', openWrap);
            if (t) t.setAttribute('aria-expanded', 'false');
        }
    });

    // ---- Fakturační údaje: přepočet ceny po změně země nebo nákupu na firmu ----
    document.addEventListener('change', function(e) {
        if (!e.target.closest('[data-ev-billing-recalculate]')) return;
        recalculateBilling(e.target.form);
    });

    // Starší odpověď by jinak přepsala cenu novější volby.
    var billingRecalculation = null;

    function recalculateBilling(form) {
        var submit = form && $('[data-ev-billing-recalculate-submit]', form);
        if (!submit) return;
        if (billingRecalculation) billingRecalculation.abort();
        var controller = billingRecalculation = new AbortController();
        var data = new FormData(form);
        data.append(submit.name, submit.value);
        fetch(form.getAttribute('action'), {
            method: 'POST',
            body: data,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            signal: controller.signal
        })
            .then(function(r) { return r.json(); })
            .then(applySnippets)
            .catch(function() {});
    }

    // ---- Souhlas s podmínkami: tlačítka se zpřístupní až po zaškrtnutí ----
    // Vizuální zámek dělá CSS (.terms-gate:not(:has(…:checked))). Tady jen doplňujeme
    // aria-disabled a blokujeme klávesnici i prohlížeče, které :has() neumí.
    function syncTermsGate(gate) {
        var box = $('[data-terms-consent]', gate);
        var locked = !!box && !box.checked;
        $$('.btn', gate).forEach(function(btn) {
            btn.setAttribute('aria-disabled', locked ? 'true' : 'false');
            if (locked) btn.setAttribute('tabindex', '-1');
            else btn.removeAttribute('tabindex');
        });
    }

    function syncTermsGates() {
        $$('.terms-gate').forEach(syncTermsGate);
    }

    document.addEventListener('change', function(e) {
        var box = e.target.closest('[data-terms-consent]');
        if (box) {
            var gate = box.closest('.terms-gate');
            if (gate) syncTermsGate(gate);
        }
    });

    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.terms-gate .btn');
        if (btn && btn.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });

    // ---- Stránka s kódem voucheru (/code) ----
    function fitVoucherInput() {
        var input = $('.ev-voucher__input');
        if (!input) return;
        input.style.fontSize = '';
        if (!input.value || !input.clientWidth) return;
        var fontSize = parseFloat(getComputedStyle(input).fontSize);
        while (input.scrollWidth > input.clientWidth && fontSize > 12) {
            fontSize -= 0.5;
            input.style.fontSize = fontSize + 'px';
        }
    }

    // Stránka kódu je pevný rám (.ev-voucher, position: fixed) přes viditelnou plochu. Klávesnice na iOS
    // nezmenší ani stránku, ani 100dvh, jen posune pohled - rám proto dostane výšku a posun visualViewport.
    // Zpět se natahuje hned na focusout - resize pošle iOS až po animaci zasunutí a pruh by do té doby visel
    // ve vzduchu. Jen když prst mačká něco v pruhu, čeká se na klik, jinak by „Ověřit" uteklo zpod prstu.
    var voucherBarPressed = false;
    var voucherBarTimer = null;

    // mezera nad textem: plná (72,5 px), nebo zúžená na šířku vytrácení (is-compact v _store.scss)
    var VOUCHER_BODY_GAP = 72.5;
    var VOUCHER_BODY_GAP_COMPACT = 24;

    // Rozhoduje se podle toho, jestli by se text vešel s plnou mezerou - jinak by se po zúžení vešel,
    // mezera by se vrátila a stránka by cukala.
    function compactVoucherBody(body) {
        var top = body.parentElement;
        var style = getComputedStyle(body);
        var content = body.scrollHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
        var space = top.clientHeight;
        Array.prototype.forEach.call(top.children, function(child) {
            if (child === body) return;
            var childStyle = getComputedStyle(child);
            space -= child.offsetHeight + parseFloat(childStyle.marginBottom);
            // horní okraj alertu je auto (tlačí ho k pruhu) - je to volné místo, ne obsazené
            if (!child.classList.contains('ev-voucher__alert')) space -= parseFloat(childStyle.marginTop);
        });
        body.classList.toggle('is-compact', content + VOUCHER_BODY_GAP + parseFloat(style.paddingBottom) > space + 0.5);
    }

    function fadeVoucherBody() {
        var body = $('.ev-voucher__body');
        if (!body) return;
        body.classList.toggle('is-fade-top', body.scrollTop > 1);
        body.classList.toggle('is-fade-bottom', body.scrollHeight - body.clientHeight - body.scrollTop > 1);
    }

    function layoutVoucherBody() {
        var body = $('.ev-voucher__body');
        if (!body) return;
        compactVoucherBody(body);
        fadeVoucherBody();
    }

    function fitVoucherPage(closing) {
        var page = $('.ev-voucher');
        var viewport = window.visualViewport;
        if (!page) return;
        var keyboard = !!viewport
            && closing !== true
            && document.activeElement === $('.ev-voucher__input', page)
            && viewport.scale < 1.01
            && document.documentElement.clientHeight - viewport.height > 100;
        page.classList.toggle('is-keyboard', keyboard);
        if (keyboard) {
            page.style.setProperty('--ev-voucher-h', viewport.height + 'px');
            page.style.setProperty('--ev-voucher-top', viewport.offsetTop + 'px');
        } else {
            page.style.removeProperty('--ev-voucher-h');
            page.style.removeProperty('--ev-voucher-top');
        }
        layoutVoucherBody();
    }

    function releaseVoucherBar() {
        if (!voucherBarPressed) return;
        voucherBarPressed = false;
        clearTimeout(voucherBarTimer);
        // až po výchozí akci kliku, odeslání formuláře doběhne na původním místě tlačítka
        setTimeout(fitVoucherPage, 0);
    }

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', function() {
            fitVoucherPage();
        });
        // iOS může pohled s klávesnicí posunout i bez resize, rám jde s ním
        // iOS posune pohled hned po ťuknutí do pole, resize pošle až po animaci klávesnice - rám jde
        // s pohledem od první chvíle, jinak by nadpis odjel za horní okraj a pak skočil zpátky
        window.visualViewport.addEventListener('scroll', function() {
            var page = $('.ev-voucher');
            if (page && window.visualViewport.scale < 1.01) {
                page.style.setProperty('--ev-voucher-top', window.visualViewport.offsetTop + 'px');
            }
        });
    }

    window.addEventListener('resize', layoutVoucherBody);

    document.addEventListener('transitionend', function(e) {
        if (e.target.classList && e.target.classList.contains('ev-voucher__body')) fadeVoucherBody();
    });

    // první ťuknutí do pole zaměří pole bez posunu pohledu, iOS ho jinak odsune nahoru i s nadpisem
    document.addEventListener('touchend', function(e) {
        var input = e.target.closest('.ev-voucher__input');
        if (!input || document.activeElement === input) return;
        e.preventDefault();
        input.focus({ preventScroll: true });
        input.setSelectionRange(input.value.length, input.value.length);
    });

    document.addEventListener('scroll', function(e) {
        if (e.target.classList && e.target.classList.contains('ev-voucher__body')) fadeVoucherBody();
    }, true);

    // Tažení prstem posouvá jen text, nikdy stránku ani pohled - iOS ho s klávesnicí jinak nechá odjet
    // nahoru. Text smí jen svisle a jen dokud má kam, na konci by iOS tah předal pohledu.
    var voucherTouch = null;

    function canScrollVoucherBody(body, dx, dy) {
        if (Math.abs(dx) > Math.abs(dy)) return false;
        if (dy > 0) return body.scrollTop > 0;
        if (dy < 0) return body.scrollTop + body.clientHeight < body.scrollHeight - 1;
        return true;
    }

    document.addEventListener('touchstart', function(e) {
        var touch = e.touches[0];
        voucherTouch = touch ? { x: touch.clientX, y: touch.clientY } : null;
    }, { passive: true });

    document.addEventListener('touchmove', function(e) {
        if (!$('.ev-voucher')) return;
        var touch = e.touches[0];
        var body = e.target.closest('.ev-voucher__body');
        var allowed = body && touch && voucherTouch && e.touches.length === 1
            && canScrollVoucherBody(body, touch.clientX - voucherTouch.x, touch.clientY - voucherTouch.y);
        if (touch) voucherTouch = { x: touch.clientX, y: touch.clientY };
        if (!allowed) e.preventDefault();
    }, { passive: false });

    // zmenšené písmo dlouhého kódu (pod 16 px) by iOS po ťuknutí přiblížilo a stránka by šla posouvat do stran
    if ($('.ev-voucher')) {
        // platí poslední značka, layout a headEvmanager dávají každý svou
        var voucherViewport = $$('meta[name="viewport"]').pop();
        if (voucherViewport) voucherViewport.setAttribute('content', voucherViewport.getAttribute('content') + ',maximum-scale=1');
    }

    document.addEventListener('focusin', function(e) {
        if (e.target.closest('.ev-voucher__input')) fitVoucherPage();
    });

    document.addEventListener('focusout', function(e) {
        if (e.target.closest('.ev-voucher__input') && !voucherBarPressed) fitVoucherPage(true);
    });

    document.addEventListener('pointerdown', function(e) {
        if (!e.target.closest('.ev-voucher__bar')) return;
        voucherBarPressed = true;
        clearTimeout(voucherBarTimer);
        // pojistka pro dotyk, ze kterého klik nebude (posun prstem)
        voucherBarTimer = setTimeout(releaseVoucherBar, 600);
    }, true);

    document.addEventListener('click', function(e) {
        if (e.target.closest('.ev-voucher__bar')) releaseVoucherBar();
    });

    document.addEventListener('pointercancel', releaseVoucherBar);

    // tlačítko „Ověřit" / „Použít" podle stavu, pruh je mimo snippet
    function setVoucherState(state) {
        var content = $('.ev-voucher__content');
        var btn = content && $('[data-ev-voucher-btn]', content);
        if (!btn) return;
        content.setAttribute('data-state', state);
        if (state === 'valid') {
            btn.setAttribute('formaction', btn.getAttribute('data-use-action'));
            btn.setAttribute('formmethod', 'post');
            btn.textContent = btn.getAttribute('data-use-label');
        } else {
            btn.removeAttribute('formaction');
            btn.removeAttribute('formmethod');
            btn.textContent = btn.getAttribute('data-verify-label');
        }
    }

    document.addEventListener('input', function(e) {
        if (!e.target.closest('.ev-voucher__input')) return;
        fitVoucherInput();
        setVoucherState('typing');
    });

    function applyVoucherPayload(payload, url) {
        if (payload.redirect) {
            window.location.href = payload.redirect;
            return;
        }
        var snippets = payload.snippets || {};
        Object.keys(snippets).forEach(function(id) {
            var el = document.getElementById(id);
            if (el) el.innerHTML = snippets[id];
        });
        var marker = $('[data-ev-voucher-state]');
        var state = marker ? marker.getAttribute('data-ev-voucher-state') : null;
        if (state) setVoucherState(state);
        if (url) rememberVoucherStep(state, url);
        fitTitles();
        fitVoucherInput();
        fitVoucherPage();
    }

    // Kroky stránky kódu v historii prohlížeče: zadání kódu a ověřený kód jsou dva záznamy, aby tlačítka
    // zpět / vpřed chodila po stejných krocích jako šipka. Zadání má adresu ?edit=, ta kód jen vyplní a
    // neověřuje, takže návrat zpět nikdy nezapočítá pokus do limitu.
    function rememberVoucherStep(state, url) {
        var verified = !!(history.state && history.state.evVoucherValid);
        if (state !== 'valid' || verified) {
            history.replaceState({ evVoucher: true, evVoucherValid: state === 'valid', evVoucherPushed: verified && history.state.evVoucherPushed }, '', url);
            return;
        }
        var form = $('[data-ev-voucher-form]');
        var code = new URL(url, location.href).searchParams.get('code') || '';
        history.replaceState({ evVoucher: true }, '', form.getAttribute('action') + '?edit=' + encodeURIComponent(code));
        history.pushState({ evVoucher: true, evVoucherValid: true, evVoucherPushed: true }, '', url);
    }

    // záznam si stav drží i po návratu z fakturace nebo obnovení stránky, příznak vloženého kroku nesmí zmizet
    if ($('.ev-voucher')) {
        var voucherMarker = $('[data-ev-voucher-state]');
        history.replaceState(Object.assign({}, history.state, {
            evVoucher: true,
            evVoucherValid: !!voucherMarker && voucherMarker.getAttribute('data-ev-voucher-state') === 'valid'
        }), '', location.href);
    }

    // zpět / vpřed v rámci stránky kódu: stav se načte z adresy záznamu, pole s kódem zůstává
    window.addEventListener('popstate', function(e) {
        if (!e.state || !e.state.evVoucher || !$('.ev-voucher')) return;
        fetch(location.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(payload) { applyVoucherPayload(payload, null); })
            .catch(function() { location.reload(); });
    });

    // Šipka zpět jde po historii, když vede tam, odkud člověk přišel - jinak by přidala nový záznam
    // a tlačítko zpět prohlížeče by pak vedlo dopředu.
    document.addEventListener('click', function(e) {
        var back = e.target.closest('.icon-btn--back');
        if (!back) return;
        if ($('.ev-voucher')) {
            if (history.state && history.state.evVoucherValid) {
                e.preventDefault();
                if (history.state.evVoucherPushed) history.back(); else location.replace(back.href);
                return;
            }
        }
        var target = back.getAttribute('data-ev-back-path') || ($('.ev-voucher') ? new URL(back.href, location.href).pathname : null);
        if (!target || !document.referrer) return;
        var referrer = new URL(document.referrer);
        if (referrer.origin !== location.origin || referrer.pathname !== target) return;
        e.preventDefault();
        history.back();
    });

    // bez JS je ověření obyčejný GET na ?code=, s JS se jen překreslí snippet a přepíše adresa
    document.addEventListener('submit', function(e) {
        var form = e.target.closest('[data-ev-voucher-form]');
        if (!form || !window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = e.submitter || $('[data-ev-voucher-btn]', form);
        var post = btn && btn.getAttribute('formmethod') === 'post';
        var data = new FormData(form);
        var url = post
            ? btn.getAttribute('formaction')
            : form.getAttribute('action') + (form.getAttribute('action').indexOf('?') === -1 ? '?' : '&') + new URLSearchParams(data).toString();
        if (btn) btn.disabled = true;
        fetch(url, {
            method: post ? 'POST' : 'GET',
            body: post ? data : undefined,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
        })
            .then(function(r) { return r.json(); })
            .then(function(payload) {
                if (btn) btn.disabled = false;
                applyVoucherPayload(payload, post ? null : url);
            })
            .catch(function() {
                if (!post) {
                    window.location.href = url;
                    return;
                }
                form.setAttribute('method', 'post');
                form.setAttribute('action', url);
                form.submit();
            });
    });

    fitVoucherInput();
    layoutVoucherBody();

    function fitAll() {
        fitButtons();
        fitTitles();
        fitCardNames();
    }

    function refitEverything() {
        fitAll();
        $$('.card.is-expanded').forEach(function(card) {
            fitCtaText(card);
            fitFeatureLabels(card);
        });
    }

    var resizeTimer;
    function scheduleRefit() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refitEverything, 150);
    }

    // Pojistka na cokoliv, co změní layout mimo resize okna: pozdě dorazivší Montserrat
    // (je širší než fallback font), přepnutí jazyka/měny, delší cena po překreslení.
    // Bez toho by název zůstal ve své původní velikosti a mohl by se odříznout.
    var stackObserver = window.ResizeObserver ? new ResizeObserver(scheduleRefit) : null;
    function observeStacks() {
        if (!stackObserver) return;
        stackObserver.disconnect();
        $$('.card-stack, .recap-card').forEach(function(el) { stackObserver.observe(el); });
    }

    fitAll();
    syncTermsGates();
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fitAll);
    }
    window.addEventListener('load', fitAll);
    window.addEventListener('resize', scheduleRefit);
    observeStacks();
})();
